// import initSentry from "./utils/sentry";
// initSentry();

import "@picocss/pico/css/pico.min.css";

import { initializeApp, type FirebaseApp } from "firebase/app";
import {
  AuthService,
  type AuthConfig,
  type InstitutionUserWithAccessRole,
} from "@magickainteractive/webauth";
import { Modal } from "@magickainteractive/modals";
import { Firestore, getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCj6olj5kvdGhl32pJlxL8wq20oxIWWmpo",
  authDomain: "slam4edu.firebaseapp.com",
  projectId: "slam4edu",
  storageBucket: "slam4edu.appspot.com",
  messagingSenderId: "640905549057",
  appId: "1:640905549057:web:75bdaa2656f2bb8e48b700",
};


const app: FirebaseApp = initializeApp(firebaseConfig);
export const defaultDb: Firestore = getFirestore(app);
export const visageDb: Firestore = getFirestore(app, "visage");
export let user: InstitutionUserWithAccessRole | null = null;
export let authConfig: AuthConfig;

authConfig = {
  apiEndpoint: "https://api.mgka.net",
  accountDomain: "https://account.mgka.net",
  redirectUri: "https://visage.mgka.net",
  appId: "MS5KDbK36hS7sq6skfr9",
  firebaseApp: app,
};

// if localhost, different config
if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1"
) {
  console.warn("[init] Running on localhost, using local auth config.");
  authConfig = {
    apiEndpoint: "http://127.0.0.1:5001/slam4edu/us-central1/api",
    accountDomain: "http://127.0.0.1:1240",
    redirectUri: "http://127.0.0.1:1265",
    appId: "MS5KDbK36hS7sq6skfr9",
    firebaseApp: app,
  };
}

const authService = new AuthService(authConfig);

document.addEventListener("DOMContentLoaded", async () => {
  try {
    await authService.doAuth().then(succesfulLogin);
  } catch (err) {
    console.error("[DOMContentLoaded] Error:", err);

    // show error message in login-desc
    const loginDesc = document.getElementById("login-desc");
    if (loginDesc) {
      loginDesc.innerHTML =
        "An error occurred. Please refresh the page, or try again later.";
    }
  }
});

// Successful login - show the app container
async function succesfulLogin() {
  console.log("[succesfulLogin] Successful login!");

  user = authService.getUser();
  console.log(
    `[succesfulLogin] Logged in as ${user?.displayName} (${user?.email}) [${user?.uid}] with role ${user?.role} in institution ${user?.institutionId}`
  );

  // Add account name to the account dropdown
  const accountName = document.getElementById("account-name");
  if (accountName && user?.displayName) {
    accountName.textContent = user?.displayName;
  }

  configureEventHandlers();

  // switch the login container to the app container
  const loginContainer = document.getElementById("login-container");
  if (loginContainer) {
    loginContainer.style.display = "none";
  }

  const appContainer = document.getElementById("app-container");
  if (appContainer) {
    appContainer.style.display = "block";
  }

  // Load cohorts after successful login
  try {
    const { loadCohorts } = await import("./cohorts");
    loadCohorts();
  } catch (error) {
    console.error("Error loading cohorts:", error);
  }

  console.log("[succesfulLogin] App load complete.");
}

function configureEventHandlers() {
  const newCohortButton = document.getElementById("new-cohort-button");
  if (newCohortButton) {
    newCohortButton.addEventListener("click", () => {
      console.log("New cohort button clicked");
      // show a modal with a form to create a new cohort
      const modal = new Modal({
        title: "New Cohort",
        // name and radio button type - signatures or photos
        content: `
          <input type="text" id="cohort-name" placeholder="Cohort Name">
          <div>
            <input type="radio" id="cohort-type-signatures" name="cohort-type" value="signatures" checked>
            <label for="cohort-type-signatures">Signatures</label>
            <input type="radio" id="cohort-type-photos" name="cohort-type" value="photos">
            <label for="cohort-type-photos">Photos</label>
          </div>
        `,
        actions: [
          {
            label: "Create",
            action: async () => {
              console.log("Create button clicked");
              const cohortName = document.getElementById(
                "cohort-name"
              ) as HTMLInputElement;
              const cohortType = document.querySelector(
                'input[name="cohort-type"]:checked'
              ) as HTMLInputElement;
              
              if (cohortName && cohortName.value.trim() && cohortType) {
                try {
                  const { createCohort } = await import("./cohorts");
                  await createCohort(cohortName.value.trim(), cohortType.value as "signatures" | "photos");
                  modal.close();
                  // Reload cohorts to show the new one
                  const { loadCohorts } = await import("./cohorts");
                  loadCohorts();
                } catch (error) {
                  console.error("Error creating cohort:", error);
                  // You could show an error message here
                }
              } else {
                console.error("Missing cohort name or type");
              }
            },
          },
        ],
      });
      modal.open();
    });
  }

  const logoutButton = document.getElementById("logout-button");
  if (logoutButton) {
    logoutButton.addEventListener("click", () => {
      console.log("Logout button clicked");
      // redirect to the account domain with ?logout=true
      window.location.href = `${authConfig.accountDomain}?logout=true`;
    });
  }

  console.log("[configureEventHandlers] Configured event handlers.");
}
